import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WidthNormalIcon(props: IconProps) {
    return <Icon {...props} iconKey={"width_normal"}/>
}
